import React, {forwardRef, useContext} from 'react';
import {CHAT_ROUTE, FAVOURITES_ROUTE, GLOBAL_REVIEWS_ROUTE, MAIN_ROUTE} from "../../../../utils/consts";
import { observer } from "mobx-react-lite";
import {useHistory, useLocation} from "react-router-dom";

import logo from "../../../../Assets/21.png"
import chatIcon from "../../../../Assets/BottomMenu/chatIcon.svg"
import Favourites from "../../../../Assets/hearts/heart-black.svg"

import styles from './NavBar.module.css';

import { reachGoal } from "../../../../utils/metrika/metrika";
import UserMiniProfile from "../../../profile/UserMiniProfile/UserMiniProfile";
import {Context} from "../../../../index";

const NavBar = observer(forwardRef((props, ref) => {
    const { chat, user } = useContext(Context);
    const history = useHistory();
    const location = useLocation();

    const isFavouritesPage = location.pathname.startsWith(FAVOURITES_ROUTE); // <-- ИЗМЕНЕНО: Используем startsWith для активности
    const isChatPage = location.pathname.startsWith(CHAT_ROUTE);

    const totalUnreadCount = chat.unreadChatsCount;

    // Обработчик клика для элемента "Избранное" (из MobileBottomNav)
    const handleFavouritesClick = () => {
        history.push(FAVOURITES_ROUTE);
        reachGoal("history.push(FAVOURITES_ROUTE) NAVIGATION");
    };

    // Обработчик клика для элемента "Сообщения" (из MobileBottomNav)
    const handleChatClick = () => {
        history.push(CHAT_ROUTE);
        reachGoal("history.push(CHAT_ROUTE) NAVIGATION");
    };

    return (
        <div
            className={`${styles.navBarWrapper} ${isFavouritesPage ? styles.favouritesPageMod : ''}`}
            ref={ref}
        >
            <div className="container-custom">
                <div className={styles.navBarContent}>
                    <div className={styles.navBarLogo}>
                        <button
                            onClick={() => {
                                history.push(MAIN_ROUTE);
                                reachGoal("history.push(MAIN_ROUTE) LOGO");
                            }}
                            className={styles.logoButton}
                        >
                            <img
                                alt="Логотип"
                                src={logo}
                                className={styles.logoImage}
                            />
                        </button>
                    </div>

                    <div className={styles.userActions}>
                        {!user.isAuth && (
                            <>
                                {/* 1. Кнопка "Сообщения" */}
                                <button
                                    className={`${styles.actionButton} ${isChatPage ? styles.actionButtonActive : ''} ${styles.mobileHide}`}
                                    onClick={handleChatClick}
                                    title="Сообщения"
                                >
                                    <img
                                        src={chatIcon}
                                        alt="Сообщения"
                                        height={30}
                                        className={styles.actionIcon}
                                        style={{padding: "2px"}}
                                    />
                                    {totalUnreadCount > 0 && (
                                        <div className={styles.badge}>
                                            {totalUnreadCount}
                                        </div>
                                    )}
                                </button>

                                {/* 2. Кнопка "Избранное" */}
                                <button
                                    className={`${styles.actionButton} ${isFavouritesPage ? styles.actionButtonActive : ''} ${styles.mobileHide}`}
                                    onClick={handleFavouritesClick}
                                    title="Избранное"
                                >
                                    <img
                                        src={Favourites}
                                        alt="Избранное"
                                        className={styles.actionIcon}
                                    />
                                </button>
                            </>
                        )}
                        <button
                            className={styles.reviewButton}
                            onClick={() => {
                                history.push(GLOBAL_REVIEWS_ROUTE);
                                reachGoal("history.push(GLOBAL_REVIEWS_ROUTE)");
                            }}
                        >
                            Отзывы
                        </button>
                        <UserMiniProfile/>
                    </div>
                </div>
            </div>
        </div>
    );
}));

export default NavBar;